import React from 'react';
import { RedocStandalone } from 'redoc';

import sellridApidocs from './sellridApidocs.json';

function SellridApidocs() {
    return (
        <div>
            <RedocStandalone spec={sellridApidocs} options={{ scrollYOffset: 100 }} />
        </div>
    );
}

export default SellridApidocs;
